import { packingSlipSchema } from "@redotech/redo-model/packing-slips/packing-slip-definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getPackingSlipTemplate = {
  name: "getPackingSlipTemplate" as const,
  input: z.object({ packingSlipId: zExt.objectId() }),
  output: packingSlipSchema,
};
